"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var accounting_1 = require("./accounting");
var utils_1 = require("./utils");
var VueCurrencyFilter = {
    install: function (Vue, options) {
        var defaultConfig = {
            name: 'currency',
            symbol: '',
            thousandsSeparator: '.',
            fractionCount: 0,
            fractionSeparator: ',',
            symbolPosition: 'front',
            symbolSpacing: true
        };
        if (utils_1.__isNull(options))
            options = {};
        var globalConfigs = utils_1.__defaults(options, defaultConfig);
        var name = globalConfigs.name, configs = __rest(globalConfigs, ["name"]);
        var filterCurrency = function (value, _symbol, _thousandsSeparator, _fractionCount, _fractionSeparator, _symbolPosition, _symbolSpacing) {
            var runtimeConfig = utils_1.__defaults({
                symbol: _symbol,
                thousandsSeparator: _thousandsSeparator,
                fractionCount: _fractionCount,
                fractionSeparator: _fractionSeparator,
                symbolPosition: _symbolPosition,
                symbolSpacing: _symbolSpacing
            }, configs);
            if (typeof _symbol === 'object') {
                runtimeConfig = utils_1.__defaults(_symbol, configs);
            }
            var result = 0.0;
            var isNegative = String(value).charAt(0) === '-';
            if (isNegative) {
                value = String(value).slice(1);
            }
            var amount = parseFloat(value);
            if (!isNaN(amount)) {
                result = amount;
            }
            var formatConfig = '%s%v';
            if (runtimeConfig.symbolPosition === 'front') {
                formatConfig = runtimeConfig.symbolSpacing ? '%s %v' : '%s%v';
            }
            else {
                formatConfig = runtimeConfig.symbolSpacing ? '%v %s' : '%v%s';
            }
            if (runtimeConfig.fractionCount > 0) {
                value = accounting_1.toFixed(value, runtimeConfig.fractionCount);
            }
            // @ts-ignore
            result = accounting_1.formatMoney(value, {
                format: formatConfig,
                symbol: runtimeConfig.symbol,
                precision: runtimeConfig.fractionCount,
                thousand: runtimeConfig.thousandsSeparator,
                decimal: runtimeConfig.fractionSeparator
            });
            if (isNegative) {
                // @ts-ignore
                result = '-' + result;
            }
            return result;
        };
        Vue.filter(name, filterCurrency);
        Vue.prototype.$CurrencyFilter = {
            setConfig: function (options) {
                configs = utils_1.__defaults(options, defaultConfig);
            },
            getConfig: function () {
                return configs;
            }
        };
    }
};
exports["default"] = VueCurrencyFilter;
